module.exports = __webpack_public_path__ + "img/synergy-retreat.71fee58a.jpg";